import { render } from "./ExhibitionTicketFace.vue?vue&type=template&id=26d4af20&scoped=true"
import script from "./ExhibitionTicketFace.vue?vue&type=script&lang=js"
export * from "./ExhibitionTicketFace.vue?vue&type=script&lang=js"

import "./ExhibitionTicketFace.vue?vue&type=style&index=0&id=26d4af20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d4af20"]])

export default __exports__